import PropTypes from 'prop-types';
import { iconsList } from '../../icon/glyphs';

export const TreeViewActionType = PropTypes.shape({
  title: PropTypes.string,
  glyph: PropTypes.oneOf(iconsList),
  onClick: PropTypes.func,
});

export const ListItem = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  actions: PropTypes.arrayOf(TreeViewActionType),
  customDragTrigger: PropTypes.element,
});

export const DnDOffset = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
});
